import { supabase } from '../supabaseClient';

// Trip cover photos: a Google Places photo of the destination, fetched once by
// the plan-trip edge function (`cover` mode) and kept in the private
// stop-photos bucket under place/, which any signed-in user may read.

const BUCKET = 'stop-photos';
const URL_TTL_SECONDS = 60 * 60;

export interface Attribution {
  name: string;
  uri: string | null;
}

/** Signed URLs for cover paths, keyed by path. Missing or failed paths are left out. */
export async function coverUrls(paths: (string | null | undefined)[]): Promise<Record<string, string>> {
  const unique = Array.from(new Set(paths.filter((p): p is string => !!p)));
  if (!unique.length) return {};
  const { data } = await supabase.storage.from(BUCKET).createSignedUrls(unique, URL_TTL_SECONDS);
  const out: Record<string, string> = {};
  for (const row of data ?? []) if (row.path && row.signedUrl) out[row.path] = row.signedUrl;
  return out;
}

/** Make sure a trip has a cover; returns its storage path, or null if none could be found. */
export async function ensureCover(tripId: string, force = false): Promise<{ path: string | null; attribution: Attribution[] | null }> {
  const { data, error } = await supabase.functions.invoke('plan-trip', { body: { mode: 'cover', trip_id: tripId, force } });
  if (error || !data) return { path: null, attribution: null };
  return { path: data.cover_photo_path ?? null, attribution: data.cover_photo_attribution ?? null };
}
